module.exports = __webpack_public_path__ + "img/MDI-information-outline.adb9dee7.svg";